import { combineReducers } from 'redux'

import selectedColumns from './selectedColumns'
import availableColumns from './availableColumns'

export default combineReducers({
  selectedColumns,
  availableColumns,
})
